/**
 * @file: 男科中心request
 */

import {
  IAndrologyFeatureEntrance,
  IAndrologyIllnessInfo
} from '@/schemas/andrology-center';
import { ApiConfigs, Response } from '@/schemas/service';
import { checkResponse } from '@/utils/helpers';
import { request } from './request';

type ApiConfigsType = 'queryFeatureEntrance' | 'queryAndrologyIllnessList';

const api: ApiConfigs<ApiConfigsType> = {
  queryFeatureEntrance: {
    url: '/health/api/v1/andrology/featureEntrance',
    method: 'GET'
  },
  queryAndrologyIllnessList: {
    url: '/health/api/v1/andrology/queryAndrologyIllnessVOList',
    method: 'GET'
  }
};

interface IQuest<T> {
  code: string;
  message?: string;
  result: T;
}

const andrologyCenter = {
  async getAndrologyFeatureEntrance() {
    try {
      const response: Response<IAndrologyFeatureEntrance[]> = await request(
        api.queryFeatureEntrance,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code, result } = response;

      if (checkResponse(code, result)) {
        return result;
      }

      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAndrologyIllnessList() {
    try {
      const response = await request<IQuest<IAndrologyIllnessInfo[]>>(
        api.queryAndrologyIllnessList,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { code, result } = response;

      if (checkResponse(code, result)) {
        const tabs = result.map((item, index) => {
          return {
            key: index,
            value: item.illnessCategory
          };
        });

        return { result, tabs };
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default andrologyCenter;
